const NotificationsTypes = {
  // Notification SSE
  SSE_NOTIFICATION_SUCCESS: "SSE_NOTIFICATION_SUCCESS",
  SSE_NOTIFICATION: "SSE_NOTIFICATION",

  POST_NOTIFICATION: "POST_NOTIFICATION",
}

export default NotificationsTypes
